import { isDefined } from '@spotify/confidence-core-react';
import {
  GroupFragment,
  IdentityFragment,
  getError,
  getTypeOrNull,
  useCurrentUserGroupsQuery,
} from '@spotify/confidence-graphql';

const identityNameFromGroup = (group: GroupFragment) => {
  // this is a hack to get the identity name.
  // the identity name for groups is 'identity/g{groupId}'
  return group.name.replace('groups/', 'identities/g');
};

export function useCurrentUserGroups(options?: { skip?: boolean }) {
  const {
    loading,
    data,
    error: networkError,
  } = useCurrentUserGroupsQuery({
    fetchPolicy: 'cache-first',
    skip: options?.skip,
  });

  const userGroups = getTypeOrNull(data?.currentUser)?.user?.userGroups;
  const appError = getError(data?.currentUser);

  const groups: GroupFragment[] =
    getTypeOrNull(userGroups)
      ?.userGroups.map(ug => ug.group)
      .filter(isDefined) ?? [];

  const identities: IdentityFragment[] = groups.map(g => ({
    __typename: 'IamV1Identity',
    // this is a hack to get the identity name.
    // the identity name for groups is 'identity/g{groupId}'
    name: identityNameFromGroup(g),
    displayName: g.displayName,
    group: g,
  }));

  return {
    isLoading: loading,
    error: appError ?? networkError,
    groups,
    identities,
  };
}
